import React from "react";
import PropTypes from "prop-types";
import Table from "../../common/Table";
import { faPencilAlt, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Button } from "react-bootstrap";

const ActionFieldTable = ({ actionFields, locale, onClick, onEdit, onDelete }) => (
  <Table
    striped
    hover
    columns={[
      {
        name: "name",
        labelKey: "indicator.management.action.field",
        customBodyRenderer: (actionField) => (
          <Button variant="link" onClick={() => onClick(actionField)}>
            {actionField.name[locale]}
          </Button>
        )
      },
      {
        name: "management",
        className: "actions",
        labelKey: "app.common.title.actions",
        actions: [
          {
            code: "edit",
            labelKey: "app.common.action.edit",
            icon: faPencilAlt,
            onClick: (actionField) => onEdit(actionField)
          },
          {
            code: "delete",
            labelKey: "app.common.action.delete",
            className: "text-danger",
            icon: faTrash,
            onClick: (actionField) => onDelete(actionField.id)
          }
        ]
      }
    ]}
    data={actionFields}
  />
);

ActionFieldTable.propTypes = {
  actionFields: PropTypes.arrayOf(PropTypes.object),
  locale: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  onEdit: PropTypes.func
};

export default ActionFieldTable;
